import {
  fetchApiGeoGeocodeCached,
  IApiGeoGeocodeCachedResponse200,
} from '../../repositories/monolith-cian-realty/api/geo/geocode-cached';
import { TThunkAction } from '../../types/redux';
import { getGeocodeRequest } from './actions';

export const getGeocode = (): TThunkAction<Promise<void>> => async (dispatch, getState, context) => {
  const state = getState();
  const {
    filters: { address },
    page: {
      queryParams: { lat, lng },
    },
  } = state;

  if (lat && lng) {
    dispatch(
      getGeocodeRequest({
        items: [
          {
            coordinates: [lng, lat], // порядок специально такой, см. useInfrastructureProps.ts
          },
        ],
      }),
    );

    return;
  }

  try {
    const response = await fetchApiGeoGeocodeCached<IApiGeoGeocodeCachedResponse200>({
      httpApi: context.httpApi,
      parameters: {
        request: address,
      },
    });

    dispatch(getGeocodeRequest(response.response));
  } catch (err) {
    context.logger.error(err);
  }
};
